exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hidden-onboarding{opacity:0}.modalmargin .modal-dialog{margin-top:5vh;height:80vh;min-height:75%;display:table;width:75%}.modalmargin .modal-content{height:100%;display:inline-table}.modalmargin .modal-body{display:inline-table;height:calc(100% - 70px);width:100%}.modalmargin{height:100vh}@media (max-width:768px){.modalmargin{margin:30px!important;width:unset!important;height:100vh}.modalmargin .modal-dialog{height:calc(100vh - 55px)!important;width:100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e3fc5f1c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/onboarding/onboarding-qrblob.vue
// module id = 1936
// module chunks = 0